import get from 'lodash/get';
import getSplashApiClient from 'lib/SplashApiClient/singleton';

export default class AgendaTouchpointApiClient {
    /**
     * @param {SplashApiClient} apiClient
     * @param {number | string} eventId
     * @param {boolean} isHostExperience
     */
    constructor(apiClient, eventId, isHostExperience = true) {
        const API_URL_PUBLIC = `/public/events/${eventId}/agenda`;
        const API_URL_PRIVATE = `/events/${eventId}/agenda`;

        this.apiClient = apiClient;
        this.eventId = eventId;
        this.isHostExperience = isHostExperience;
        this.url = isHostExperience ? API_URL_PRIVATE : API_URL_PUBLIC;
        this.options = isHostExperience ? {} : { omitAccessToken: true };
    }

    get = async () => {
        const response = await this.apiClient.get(this.url, {}, this.options);
        return get(response, 'data.meta.structure');
    };

    save = (structure) => {
        if (!this.isHostExperience) {
            return;
        }
        const data = {
            meta: { structure },
        };

        // eslint-disable-next-line consistent-return
        return this.apiClient.put(this.url, data);
    };
}

export const getAgendaTouchpointApiClient = (eventId, isHostExperience) =>
    new AgendaTouchpointApiClient(getSplashApiClient(), eventId, isHostExperience);
